import { render } from "./readExtensionMuseum.vue?vue&type=template&id=43047eb4&scoped=true"
import script from "./readExtensionMuseum.vue?vue&type=script&lang=js"
export * from "./readExtensionMuseum.vue?vue&type=script&lang=js"

import "./readExtensionMuseum.vue?vue&type=style&index=0&id=43047eb4&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43047eb4"]])

export default __exports__